import { render, staticRenderFns } from "./AddressesCard.vue?vue&type=template&id=40650a67&"
import script from "./AddressesCard.vue?vue&type=script&lang=ts&"
export * from "./AddressesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports